<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.DEACTIVATE_PRODUCT.DESCRIPTION' | translate }}
  </div>
  <glxy-alert type="warning" class="deactivate">
    <strong>{{ 'AUTOMATIONS.EDITOR.TASKS.DEACTIVATE_PRODUCT.WARNING.WARNING' | translate }}</strong>
    {{ deactivationWarning }}
  </glxy-alert>
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.DEACTIVATE_PRODUCT.DEACTIVATION_TYPE' | translate }}
    </glxy-label>
    <mat-select [formControl]="deactivationTypeControl" required="true">
      <mat-option *ngFor="let o of deactivationOptions" [value]="o.value">
        {{ o.label }}
      </mat-option>
    </mat-select>
    <glxy-hint *ngIf="deactivationHint$ | async as hint">
      {{ hint | translate }}
    </glxy-hint>
  </glxy-form-field>
  <ng-container *ngIf="apps$ | async as apps">
    <ng-container *ngIf="!isLoading">
      <ng-container *ngIf="appOptions$ | async">
        <inventory-ui-item-search-single-select-filter
          [config]="{
              partnerId: automation.namespace,
              marketId: automation.marketId,
              filters: listActivatableItemsFilterForAppType,
              customDropdownItems: [{
                appId: ALL_PRODUCTS,
                name: 'AUTOMATIONS.EDITOR.TASKS.DEACTIVATE_PRODUCT.ALL_PRODUCTS' | translate,
              }],
            }"
          [selectedItem]="{ appId: selectedAppId$ | async }"
          (selectionChange)="productSelectionChanged($event)"
        ></inventory-ui-item-search-single-select-filter>
      </ng-container>
      <ng-container *ngIf="!!productControl.value">
        <ng-container *ngIf="{ editions: editionOptions$ | async, addons: addonOptions$ | async } as options">
          <ng-container *ngIf="options.editions?.length > 1 || options.addons?.length > 1">
            <glxy-form-field required="true">
              <glxy-label>
                {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.SELECT_PRODUCT_TYPE' | translate }}
              </glxy-label>
              <mat-select [formControl]="editionsOrAddonsControl">
                <ng-container *ngFor="let o of editionsOrAddonsOptions">
                  <mat-option [value]="o.value" [disabled]="o.value === ANY_ADDON && disableAddonSelection">
                    {{ o.label }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </glxy-form-field>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="editionsOrAddonsControl.value === ANY_EDITION && editionOptions$ | async as editions">
          <ng-container *ngIf="editions.length > 0">
            <glxy-form-field required="true">
              <glxy-label>
                {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.SELECT_EDITION' | translate }}
              </glxy-label>
              <mat-select [formControl]="editionControl">
                <mat-option *ngFor="let o of editions" [value]="o.value">
                  {{ o.label | translate }}
                </mat-option>
              </mat-select>
            </glxy-form-field>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="editionsOrAddonsControl.value === ANY_ADDON && addonOptions$ | async as addons">
          <ng-container *ngIf="addons.length > 0">
            <inventory-ui-item-search-single-select-filter
              [config]="{
                  partnerId: automation.namespace,
                  marketId: automation.marketId,
                  filters: listActivatableItemsFilterForAddonType$ | async,
                  customDropdownItems: [{
                    addonId: ANY_ADDON,
                    name: 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.ALL_ADDONS' | translate
                  }],
                }"
              [selectedItem]="{ addonId: selectedAddonId$ | async }"
              (selectionChange)="addonSelectionChanged($event)"
            ></inventory-ui-item-search-single-select-filter>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- Hide the tickbox while all products is selected. It has no impact on that selection so the value doesn't matter -->
      <ng-container *ngIf="(selectedAppId$ | async) !== ALL_PRODUCTS">
        <glxy-form-field>
          <mat-checkbox [formControl]="trialControl">
            {{ 'AUTOMATIONS.EDITOR.TASKS.DEACTIVATE_PRODUCT.INCLUDE_TRIALS' | translate }}
          </mat-checkbox>
        </glxy-form-field>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-container *ngIf="isLoading">
  <div class="side-drawer-shimmer-container">
    <span class="title stencil-shimmer"></span>
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-container>
